import { SerializedStyles } from "@emotion/react";
import { Ref, memo, useCallback } from "react";
import { useNoSubmit } from "src/apps/AppFlow/pages/hooks";
import { styles } from "src/apps/AppFlow/pages/styles";
import { FormFlowPage, TextInput } from "src/components";
import { EmployerDetailsValue } from "src/types/Application";

export interface EmployerDetailsProps {
  onChange: (value: EmployerDetailsValue) => void;
  value?: EmployerDetailsValue;

  focusRef?: Ref<HTMLInputElement>;
  onNext: () => void;
  onBack: () => void;
  style?: SerializedStyles;
}

const EmployerDetails = ({
  onNext,
  onBack,
  style,
  focusRef,
  value,
  onChange,
  ...props
}: EmployerDetailsProps) => {
  const validate = useCallback(() => value?.name !== undefined, [value]);
  const { handleNext, nextDisabled } = useNoSubmit({ onNext, validate });

  const handleChangeEmployerName = useCallback(
    (employerName?: string) => {
      onChange({
        ...value,
        name: employerName,
      });
    },
    [onChange, value]
  );

  return (
    <FormFlowPage
      {...props}
      title="Employer details"
      description="We just need some basic information on your employer."
      onNext={handleNext}
      onBack={onBack}
      style={style}
      nextDisabled={nextDisabled}
    >
      <TextInput
        ref={focusRef}
        style={styles.topInput}
        name="employerName"
        label="Employer name"
        placeholder="Fraction Technologies Inc."
        value={value?.name || ""}
        onChange={handleChangeEmployerName}
      />
    </FormFlowPage>
  );
};

export default memo(EmployerDetails);
